// extracted by mini-css-extract-plugin
export var accentColor = "#ff723d";
export var categoryBorderColor = "#15ba8f";
export var disableRipple = "false";
export var mainColor = "#e96838";
export var mainContrast = "#fff";
export var panelBorderColor = "#c4c8cd";
export var secondaryColor = "#73aaaa";
export var secondaryContrast = "rgba(0,0,0,.87)";